module.exports = __webpack_public_path__ + "static/media/education.5885d466.png";